import { alternativePhonesToString } from "../components/alternative-phones/alternative-phones.utils";
import axiosClient from "../config/axios";
import { formatCUITCUIL } from "../utils/utils";

const checkPolicyBelongsToCUIT = async (cuit, policyNumber) =>
    await axiosClient.get(
        `/PolicyBelongsToCuit?cuit=${formatCUITCUIL(
            cuit.trim()
        )}&policyNumber=${policyNumber.trim()}`
    );

const registerUser = async ({
    userName,
    cuit,
    email,
    phone,
    phoneCompany,
    alternativePhones,
    password,
}) =>
    await axiosClient.post("/registerUser", {
        userName,
        cuit,
        email,
        phone,
        phoneCompany,
        alternativePhones: alternativePhonesToString(alternativePhones),
        password,
        app: "1",
    });

export { checkPolicyBelongsToCUIT, registerUser };
